import React, { Suspense } from 'react';

const DelayedAddFundsStep =
  React.lazy(() => import(/* webpackChunkName: "add-funds-step.async" */ './add-funds-step')
    .then(({ AddFundsStepWithI18n }) => ({
      default: AddFundsStepWithI18n,
    })));

export const DelayedAddFundsStepWithI18n = () => (
  <Suspense fallback={null}>
    <DelayedAddFundsStep />
  </Suspense>
);
